import {useCallback} from 'react';
import {useRouter} from 'next/router';

import {Routes} from '~constants/routes';
import {getHashId} from '~utils/map/events/useSelectPlotEvent';
import useScreenType from '~hooks/useScreenType';

export default function usePlotClick() {
    const {isList} = useScreenType();
    const router = useRouter();

    return useCallback(
        (id: number) => {
            isList
                ? router.push({pathname: Routes.Plot, query: {id}})
                : router.push(
                      {
                          pathname: router.pathname,
                          hash: getHashId(id),
                      },
                      undefined,
                      {
                          shallow: true,
                      },
                  );
        },
        [router, isList],
    );
}
